import Environment from "./__env.js";
import angular from "angular";
import $ from "jquery";

import "./angular-locale_da";

const ENV = Environment.get();

if (!ENV) {
    alert("No Env found - check __env.js file ");
}

import "angular-loading-bar";
import "angular-animate";
import "angular-aside";
import "bootstrap";
import "angular-bootstrap";
// import "angular-ui-bootstrap";
import uibDropdown from "angular-ui-bootstrap/src/dropdown";
import uibAccordion from "angular-ui-bootstrap/src/accordion";
import uibModal from "angular-ui-bootstrap/src/modal";

import "angular-route";
import "angular-sanitize";
import "angular-ui-mask";
import "angular-filter";
import "angular-cookies";
import "angular-resource";
import "angular-aria";
import "angular-local-storage";
import "angular-hotkeys";
import "ng-media-query/ng-media-query";
import "angular-touch";
import "angular-lazy-img/dist/angular-lazy-img";
import "ng-image-gallery";
import "angular-modal-service";
import "moment";
import "angular-moment";
import "angular-md5";
import "@daypilot/daypilot-lite-javascript";
import appModule from "./app/module";

import * as Sentry from "@sentry/browser";
import { Angular as AngularIntegration } from "@sentry/integrations";
import { User } from "oidc-client";

// Make sure to call Sentry.init after importing AngularJS.
// You can also pass {angular: AngularInstance} to the Integrations.Angular() constructor.
Sentry.init({
    dsn: "https://e896bafa6b1a4d0f88fdc338cb077220@o808440.ingest.sentry.io/5854529",
    integrations: [new AngularIntegration()],
});

angular
    .module("abookApp", [
        "ngAnimate",
        "ngCookies",
        "ngResource",
        "ngRoute",
        "ngSanitize",
        "ngTouch",
        "LocalStorageModule",
        "angular-md5",
        "angular-loading-bar",
        "angular.filter",
        "ngAria",
        "ui.mask",
        "angularModalService",
        "ngAside",
        uibDropdown,
        uibAccordion,
        uibModal,
        "ngMediaQuery",
        "angularLazyImg",
        "cfp.hotkeys",
        "thatisuday.ng-image-gallery",
        "angularMoment",
        "daypilot",
        appModule,
        "ngSentry",
    ])
    .constant("moment", require("moment-timezone"))
    .constant("angularMomentConfig", {
        timezone: "Europe/Copenhagen",
    })

    .constant("ENV", ENV)
    .constant("API_SERVER", ENV.api)
    .constant("API_LEGACY", ENV.apiLegacy)

    .config(function (
        $compileProvider,
        $routeProvider,
        $httpProvider,
        $locationProvider,
        cfpLoadingBarProvider,
        lazyImgConfigProvider,
        ngImageGalleryOptsProvider,
        localStorageServiceProvider,
        hotkeysProvider
    ) {
        hotkeysProvider.includeCheatSheet = false;

        $compileProvider.debugInfoEnabled(false);
        $compileProvider.commentDirectivesEnabled(false);
        $compileProvider.cssClassDirectivesEnabled(false);

        // NOTE : Using debug info in browser when disabled
        // https://docs.angularjs.org/guide/production
        // use angular.reloadWithDebugInfo(); in browser to reload with debug info

        // use the HTML5 History API // or not
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false,
        });

        $locationProvider.hashPrefix("");

        $routeProvider

            .when("/", {
                template: require("./app/pages/home/template.html"),
                controller: "homeController",
                title: "Lej nemt baner og lokaler i København",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                hasSearchBar: true,
                removeUrlParams: true,
                resolve: {
                    articles: function (siteService) {
                        return siteService.getPage(100);
                    },
                },
            })

            .when("/faq", {
                template: require("./app/pages/faq/template.html"),
                controller: "faqController",
                title: "Faq",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                removeUrlParams: true,
                resolve: {
                    articles: function (siteService) {
                        return siteService.getPage(2);
                    },
                },
            })

            .when("/practical", {
                template: require("./app/pages/practical/template.html"),
                controller: "practicalController",
                title: "Praktisk Information",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                removeUrlParams: true,
                resolve: {
                    articles: function (siteService) {
                        return siteService.getPage(4);
                    },
                },
            })

            .when("/contact", {
                template: require("./app/pages/contact/template.html"),
                controller: "contactController",
                title: "Kontakt",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                removeUrlParams: true,
                resolve: {
                    articles: function (siteService) {
                        return siteService.getPage(-5);
                    },
                },
            })

            .when("/prices", {
                template: require("./app/pages/marketprice/template.html"),
                controller: "marketpriceController",
                title: "Priser",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                removeUrlParams: true,
                resolve: {
                    articles: function (siteService) {
                        return siteService.getPage(96);
                    },
                },
            })

            .when("/activities", {
                template: require("./app/pages/activities/template.html"),
                controller: "activitiesController",
                title: "Aktiviteter",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                removeUrlParams: true,
                resolve: {
                    activities: function (houseService) {
                        return houseService.getActivities();
                    },
                },
            })

            .when("/activities/:activity", {
                template: require("./app/pages/activity/template.html"),
                controller: "activityController",
                title: "Aktivitet",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                removeUrlParams: true,
                resolve: {
                    activities: function (houseService) {
                        return houseService.getActivities();
                    },
                    locations: function (houseService) {
                        return houseService.getLocations();
                    },
                },
            })

            .when("/locations", {
                template: require("./app/pages/locations/template.html"),
                controller: "locationsController",
                title: "Steder",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                removeUrlParams: true,
                resolve: {
                    activities: function (houseService) {
                        return houseService.getActivities();
                    },

                    locations: function (LocationService) {
                        return LocationService.getAll();
                    },
                },
            })

            .when("/locations/:location", {
                template: require("./app/pages/location/template.html"),
                controller: "locationController",
                title: "Steder",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                removeUrlParams: true,
                resolve: {
                    activities: function (houseService) {
                        return houseService.getActivities();
                    },
                    locations: function (houseService) {
                        return houseService.getLocations();
                    },
                },
            })

            /**
             * SEARCH
             */

            .when("/search/activity/:activity", {
                template: require("./app/pages/search/activity/template.html"),
                controller: "SearchActivityController",
                title: "Søg aktivitet",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                hasSearchBar: true,
                removeUrlParams: false,
            })

            .when("/search/activity/:activity/calendar", {
                template: require("./app/pages/search/activity/calendar/template.html"),
                controller: "CalendarController",
                title: "Søg aktivitet",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                hasSearchBar: true,
                removeUrlParams: false,
            })

            .when("/search/activity/:activity/:location", {
                template: require("./app/pages/search/activity/template.html"),
                controller: "SearchActivityController",
                title: "Søg aktivitet",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                hasSearchBar: true,
                removeUrlParams: false,
            })

            .when("/search/location/:location", {
                template: require("./app/pages/search/location/template.html"),
                controller: "SearchLocationController",
                title: "Tider",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                hasSearchBar: true,
                removeUrlParams: false,
            })

            .when("/search/periods/:activity/:location", {
                template: require("./app/pages/search/periods/template.html"),
                controller: "SearchPeriodsController",
                title: "Tider",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                removeUrlParams: false,
                resolve: {
                    resourceDependencies: (Resources) => {
                        return Resources.getDependencies();
                    },
                },
            })

            .when("/search/periods/fixed/:activity/:location", {
                template: require("./app/pages/search/periods-fixed/template.html"),
                controller: "SearchPeriodsFixedController",
                title: "Faste baner",
                checkout: true,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                removeUrlParams: false,
                resolve: {
                    resourceDependencies: (Resources) => {
                        return Resources.getDependencies();
                    },
                    // userId: (Users) => {
                    //     return Users.isAuthenticated();
                    // },
                },
            })

            .when("/basket-fixed", {
                template: require("./app/pages/basket-fixed/template.html"),
                controller: "basketFixedController",
                title: "Kurv",
                checkout: true, // hide the basket in header
                hasHeroDesktop: false,
                hasHeroMobile: false,
                removeUrlParams: false,
                resolve: {
                    // user: (Users) => {
                    //     return Users.getAuthenticatedUser(); // will reject if not logged
                    // },
                    activities: function (houseService) {
                        return houseService.getActivities();
                    },
                    locations: function (houseService) {
                        return houseService.getLocations();
                    },
                },
            })

            .when("/basket", {
                template: require("./app/pages/basket/template.html"),
                controller: "basketController",
                title: "Kurv",
                checkout: true, // hide the basket in header
                hasHeroDesktop: false,
                hasHeroMobile: false,
                removeUrlParams: true,
                resolve: {
                    user: (Users) => {
                        return Users.getAuthenticatedUser(); // will reject if not logged
                    },
                },
            })

            .when("/checkout/bookingoptions", {
                template: require("./app/pages/checkout/booking-options/template.html"),
                controller: "bookingOptionsController",
                title: "Booking step 1",
                checkout: true,
                hasHeroDesktop: false,
                hasHeroMobile: false,
                removeUrlParams: false,
                resolve: {
                    userId: (Users) => {
                        return Users.isAuthenticated();
                    },
                },
            })

            .when("/checkout/bookinginfo", {
                // INCLUDES DIBS FORM
                template: require("./app/pages/checkout/booking-info/template.html"),
                controller: "bookingInfoController",
                title: "Booking step 2",
                checkout: true,
                hasHeroDesktop: false,
                hasHeroMobile: false,
                removeUrlParams: true,
                resolve: {
                    user: (Users) => {
                        return Users.getAuthenticatedUser(); // will reject if not logged
                    },
                },
            })

            .when("/checkout/payment-complete", {
                // DIBS ACCEPTURL
                template: require("./app/pages/checkout/payment-complete/template.html"),
                controller: "paymentCompleteController",
                title: "Betaling gennemført",
                checkout: true,
                hasHeroDesktop: false,
                hasHeroMobile: false,
                removeUrlParams: false,
            })
            .when("/checkout/booking-complete", {
                template: require("./app/pages/checkout/booking-complete/template.html"),
                controller: "BookingCompleteController",
                title: "Betaling gennemført",
                checkout: true,
                hasHeroDesktop: false,
                hasHeroMobile: false,
                removeUrlParams: false,
                resolve: {
                    user: (Users) => {
                        return Users.getAuthenticatedUser(); // will reject if not logged
                    },
                },
            })
            // .when("/bookingconfirmation", {
            //     template: require("./app/pages//checkout/bookingconfirmation.html"),
            //     controller: "BookingconfirmationCtrl",
            //     title: "Booking step 4"
            // })

            .when("/account", {
                template: require("./app/pages/account/template.html"),
                controller: "AccountController",
                title: "Konto",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                removeUrlParams: true,
            })

            .when("/account/create", {
                template: require("./app/pages/account/create/template.html"),
                controller: "AccountCreateController",
                title: "Ny bruger",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                removeUrlParams: true,
                resolve: {
                    articles: function (siteService) {
                        return siteService.getPage(91);
                    },
                },
            })

            // .when("/account/login", {
            //     template: require("./app/pages/account/login/login.html"),
            //     controller: "loginController",
            //     title: "Login",
            //     checkout: false,
            //
            //     hasHeroDesktop: true,
            //     hasHeroMobile: true,
            //     removeUrlParams: true,
            // })

            /**
             * Just a url logout - shortcut
             */

            .when("/account/reset-password-request", {
                template: require("./app/pages/account/reset-password-request/template.html"),
                controller: "AccountResetPasswordRequestController",
                title: "Anmod om nustilling af password",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                removeUrlParams: true,
            })

            .when("/account/reset-password/:uid", {
                template: require("./app/pages/account/reset-password/template.html"),
                controller: "AccountResetPasswordController",
                title: "Nulstil password",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                removeUrlParams: true,
            })

            .when("/account/profile", {
                template: require("./app/pages/account/profile/template.html"),
                controller: "AccountProfileController",
                title: "Min profil",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                removeUrlParams: true,
                resolve: {
                    user: (Users) => {
                        return Users.getAuthenticatedUser(); // will reject if not logged
                    },
                },
            })
            .when("/account/change-password", {
                template: require("./app/pages/account/change-password/template.html"),
                controller: "AccountChangePasswordController",
                title: "Skift Password",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                removeUrlParams: true,
                resolve: {
                    user: (Users) => {
                        return Users.getAuthenticatedUser(); // will reject if not logged
                    },
                },
            })
            .when("/account/bookings", {
                template: require("./app/pages/account/bookings/template.html"),
                controller: "AccountBookingsController",
                title: "Mine bookinger",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                removeUrlParams: true,
                resolve: {
                    user: (Users) => {
                        return Users.getAuthenticatedUser(); // will reject if not logged
                    },
                },
            })
            .when("/terms", {
                template: require("./app/pages/terms/template.html"),
                controller: "termsController",
                title: "Handelsbetingelser",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                removeUrlParams: true,
            })

            /**
             * used to get booking by UID (url param) - New feature (no implemetation yet)
             */
            .when("/payment-redirect", {
                template: require("./app/pages/checkout/payment-redirect/template.html"),
                controller: "PaymentRedirectController",
                title: "payment-redirect",
                checkout: false,

                hasHeroDesktop: false,
                hasHeroMobile: false,
                removeUrlParams: false,
            })

            /**
             * reciept page for payment-redirect UID
             */
            .when("/checkout/payment-receipt", {
                template: require("./app/pages/checkout/payment-receipt-uid/template.html"),
                controller: "PaymentReceiptUidController",
                title: "Kvittering",
                checkout: true,
                hasHeroDesktop: false,
                hasHeroMobile: false,
                removeUrlParams: false,
            })

            /**
             * callback from identity server
             */
            .when("/auth-callback", {
                removeUrlParams: false,
                resolve: {
                    signinRedirectCallback: (Auth) => {
                        Auth.signinRedirectCallback();
                    },
                },
            })

            /**
             * Auth test page (with authGuard)
             */

            .when("/auth-test", {
                template: require("./app/pages/auth-test/template.html"),
                controller: "authTestController",
                title: "Auth Test",
                checkout: false,
                hasHeroDesktop: true,
                hasHeroMobile: true,
                removeUrlParams: true,
                resolve: {
                    userId: function (Users) {
                        return Users.isAuthenticated();
                    },
                },
            })

            /**
             * Maintenance
             */

            .when("/maintenance", {
                template: require("./app/pages/maintenance/template.html"),
                controller: "maintenanceController",
                title: "Maintenance",
            })

            /**
             * Redirects
             */
            .when("/bookinginfo", {
                // Nets payment point to this old url (redirect to new url)
                redirectTo: "/checkout/bookinginfo",
            })

            .otherwise({
                redirectTo: "/",
            });

        // enable http caching
        $httpProvider.interceptors.push("AuthInterceptor");

        // Used for testing! // Prevent
        // $httpProvider.interceptors.push('APIInterceptor');

        // use sessionStorage
        // localStorageServiceProvider.setStorageType('sessionStorage'); // defaults to localStorage
        localStorageServiceProvider.setPrefix("abook");

        // Angular loading Bar
        const loadingMessage = "Vent venligst";
        cfpLoadingBarProvider.parentSelector = "body";
        cfpLoadingBarProvider.spinnerTemplate = `
            <div id="loading-bar-spinner">
                <div class="loading-msg"> 
                    ${loadingMessage} 
                </div>
                <div class="spinner-icon"></div>
            </div>
        `;

        var scrollable = document.querySelector("#scrollable");

        lazyImgConfigProvider.setOptions({
            offset: 10000, // how early you want to load image (default = 100)
            errorClass: null, //'error', // in case of loading image failure what class should be added (default = null)
            successClass: null, //'success', // in case of loading image success what class should be added (default = null)
            onError: function () {}, // function fired on loading error
            onSuccess: function () {}, // function fired on loading success
            container: angular.element(scrollable), // if scrollable container is not $window then provide it here
        });

        ngImageGalleryOptsProvider.setOpts({
            thumbnails: true,
            thumbSize: 80,
            inline: false,
            bubbles: true,
            bubbleSize: 20,
            imgBubbles: false,
            bgClose: false,
            piracy: false,
            imgAnim: "fadeup",
        });
    })

    .run(function (
        $route,
        $rootScope,
        $log,
        Auth,
        $location,
        amMoment,
        Users,
        $timeout
    ) {
        // add param to prevent page reload (bool) - when url changes - aBook needs this in some scenarios (overview)
        // https://www.consolelog.io/angularjs-change-path-without-reloading
        // var original = $location.path;
        // $location.path = function (path, reload) {
        //     if (reload === false) {
        //         var lastRoute = $route.current;
        //         var un = $rootScope.$on("$locationChangeSuccess", function () {
        //             $route.current = lastRoute;
        //             un();
        //         });
        //     }
        //     return original.apply($location, [path]);
        // };

        document.addEventListener(
            "focusin",
            function () {
                // console.log("focused: ", document.activeElement);
            },
            true
        );

        amMoment.changeLocale("da");

        $rootScope.$on(
            "$routeChangeError",
            (event, current, previous, rejection) => {
                switch (rejection) {
                    case Users.access.UNAUTHORIZED:
                        // USER TO SIGN IN
                        $log.warn("You must log in to access ");

                        Auth.login();
                        break;

                    case Users.access.FORBIDDEN: // not in use (Role based)
                        // $location.path("/forbidden");
                        break;

                    default:
                        $log.warn("$routeChangeError event catched");
                        break;
                }
            }
        );

        let ApiRequestCount = 0;
        $rootScope.$on("cfpLoadingBar:loading", function () {
            ApiRequestCount++;
            // console.log("loading", ApiRequestCount);
        });

        $rootScope.$on("cfpLoadingBar:loaded", function () {
            $timeout(function () {
                ApiRequestCount--; // remove when loaded
                // console.log("loaded", ApiRequestCount);

                if (ApiRequestCount <= 0) {
                    // Screen reader - Finished loading! HOW ???
                    // $("#loading-bar-spinner .loading-msg").text("");
                }
            }, 300); // This timeout ensures that the ApiRequestCount is not set to zero before all api calls have been initiated.
        });

        $rootScope.$on("$routeChangeStart", function (event, next) {
            const maintance = false;

            if (maintance) {
                Users.getCurrentUser().then((user) => {
                    // Whitelist userIds
                    const allowedUsers = [1, 693, 711, 14266];
                    if (
                        user == null ||
                        !allowedUsers.includes(Number(user.sub))
                    )
                        $location.path("/maintenance");
                });
            }

            if (!next.hasOwnProperty("$$route")) {
                return false;
            }

            // FIX ::: To agressive!
            if (next.$$route.removeUrlParams) {
                $location.url($location.path()); // removes all query params, when not search Controller
            }
        });

        $rootScope.$on("$routeChangeSuccess", function () {
            //Change page title, based on Route information
            $rootScope.originalPath = $route.current.$$route.originalPath;

            // $rootScope.metaTitle = $route.current.$$route.title;

            document.title = "Book Byen - " + $route.current.$$route.title;

            /**
             *  Browser back button - Modal fix
             * - Ensure that modal kills the backdrop and padding-left style when user navigates using the browser back button
             */
            $(".modal-backdrop").remove();
            $("body").removeAttr("style");
        });
    })

    //https://www.npmjs.com/package/ng-media-query
    .value("media", {
        xxs: [-1, 449],
        xs: [450, 767],
        sm: [768, 991],
        md: [992, 1199],
        lg: [1200, -1],
    });
